<template>
    <div class="callContent">
        <div class="video-call-section">
            <header-nav v-show="isShowVideoCall"></header-nav>
            <div v-show="!isShowVideoCall">
                <!-- <div class="video-call-section-header">
          Welcome
          {{ loginUserInfo && (loginUserInfo.name || loginUserInfo.userId) }}
        </div> -->
                <!-- <div class="video-call-section-title">视频通话</div> -->
                <search-user
                    :textTitle="'视频通话区域'"
                    :callFlag="callFlag"
                    :BtnTex="BtnText"
                    :cancelFlag="cancelFlag"
                    @callUser="handleCallUser"
                    @cancelCallUser="handleCancelCallUser"
                    @applicationInfo="applicationData"
                ></search-user>
            </div>

            <div
                style="margin-top: 50px"
                :class="{
                    'video-conference': true,
                    'is-show': isShowVideoCall
                }"
            >
                <div style="width: 63%">
                    <div class="video-conference-list">
                        <div
                            v-for="(userId, index) in meetingUserIdList"
                            :key="`video-${userId}-${index}`"
                            :id="`video-${userId}`"
                            :class="{
                                'user-video-container': true,
                                'is-me': userId === loginUserInfo.userId
                            }"
                        >
                            <div class="user-status">
                                <div
                                    :class="{
                                        'user-video-status': true,
                                        'is-mute': isUserMute(
                                            muteVideoUserIdList,
                                            userId
                                        )
                                    }"
                                ></div>
                                <div
                                    :class="{
                                        'user-audio-status': true,
                                        'is-mute': isUserMute(
                                            muteAudioUserIdList,
                                            userId
                                        )
                                    }"
                                ></div>
                            </div>
                            <div class="video-item-username">
                                {{ userId2Name[userId] }}
                                <div
                                    v-if="
                                        index == 0 &&
                                        (callStatus == 'calling' ||
                                            callStatus == 'idle')
                                    "
                                    style="
                                        position: absolute;
                                        top: 80px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                    "
                                >
                                    <img src="../../assets/zwsp.png" alt="" />
                                </div>
                                <div
                                    v-if="
                                        index == 1 &&
                                        (callStatus == 'calling' ||
                                            callStatus == 'idle')
                                    "
                                    style="
                                        position: absolute;
                                        top: 200px;
                                        left: 50%;
                                        transform: translateX(-50%);
                                    "
                                >
                                    <img src="../../assets/zwsp.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div
                            style="
                                float: left;
                                padding-left: 10px;
                                width: 45%;
                                margin-top: 45px;
                            "
                        >
                            <div
                                class="screenshots_title video-conferenc-border"
                            >
                                <div class="video-conferenc-border-title">
                                    <span>申请信息</span>
                                </div>

                                <ul class="screenshots_title_list">
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >申请表编号：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{
                                                applicationNoList.applicationNo
                                            }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >姓名：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{ applicationNoList.name }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >身份证号码：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{
                                                applicationNoList.idCard
                                            }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >生产企业：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{
                                                applicationNoList.factoryName
                                            }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >产品名称：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{
                                                applicationNoList.proName
                                            }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >机具型号：</span
                                        >
                                        <span
                                            class="screenshots_title_list_text"
                                            >{{
                                                applicationNoList.machineCode
                                            }}</span
                                        >
                                    </li>
                                    <li>
                                        <span
                                            class="screenshots_title_list_biaot"
                                            >出厂编号：</span
                                        >
                                        <el-select
                                            v-model="factoryNumberValue"
                                            @change="factoryNumberLinkage"
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="item in applicationNoList.factoryNumber"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            >
                                            </el-option>
                                        </el-select>
                                    </li>
                                    <!-- <li>
                                        <span class="screenshots_title_list_biaot">发动机号：</span>
                                        <span class="screenshots_title_list_text">{{
                                                applicationNoList.engineNumber
                                        }}</span>
                                    
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                        <div class="video-conferenc-btn video-conferenc-border">
                            <div class="btn_style_box">
                                <div
                                    class="btn_style"
                                    @click="handleUnpublish2"
                                >
                                    <img
                                        height="50"
                                        src="../../assets/jietu.png"
                                    />
                                </div>
                                <div class="btn_style_title">截图</div>
                            </div>
                            <div
                                :class="{
                                    btn_style_box: true,
                                    btn_style_box_tm: startRecordingShow
                                }"
                            >
                                <div class="btn_style" @click="startRecording">
                                    <img
                                        height="50"
                                        src="../../assets/kslz.png"
                                    />
                                </div>
                                <div class="btn_style_title">开始录制</div>
                            </div>
                            <div class="btn_style_box">
                                <div class="btn_style" @click="endRecording">
                                    <img
                                        height="50"
                                        src="../../assets/jslz.png"
                                    />
                                </div>
                                <div class="btn_style_title">结束录制</div>
                            </div>
                            <div
                                :class="{
                                    btn_style_box: true,
                                    btn_style_box_tm:
                                        videoAreaFlg || callStatus == 'idle'
                                }"
                            >
                                <div class="btn_style" @click="handleHangup">
                                    <img
                                        height="50"
                                        src="../../assets/gd.png"
                                    />
                                </div>
                                <div class="btn_style_title">挂断</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 33%" class="tipOperation">
                    <div style="width: 100%; margin-top: 20px">
                        <div
                            class="screenshots_title screenshots_title1 video-conferenc-border"
                        >
                            <div class="video-conferenc-border-title">
                                <span>核验资料</span>
                            </div>
                            <div class="video-conferenc-border-box">
                                <div
                                    class="screenshotsBox"
                                    v-for="(item, index) in imgArr"
                                    :key="index"
                                >
                                    <el-button
                                        class="screenshotsBox_decoration decoration1"
                                        @click.native.prevent="
                                            deleteRow(index, item)
                                        "
                                        type="text"
                                        size="small"
                                    >
                                        X
                                    </el-button>
                                    <div
                                        class="screenshotsBox_decoration decoration2"
                                    >
                                        截图-{{ item.name }}-{{
                                            item.factoryNumber
                                        }}
                                    </div>
                                    <el-image
                                        class="screenshotsBox_decoration decoration3"
                                        style="width: 150px; height: 150px"
                                        :src="item.show"
                                        :preview-src-list="[item.show]"
                                    >
                                    </el-image>
                                </div>
                                <div
                                    class="screenshotsBox"
                                    v-for="(ele, index) in VideoArr"
                                    :key="index + 'dhf'"
                                >
                                    <el-button
                                        class="screenshotsBox_decoration decoration1"
                                        @click.native.prevent="
                                            deleteVideo(ele, index)
                                        "
                                        type="text"
                                        size="small"
                                    >
                                        X
                                    </el-button>
                                    <div
                                        class="screenshotsBox_decoration decoration2"
                                    >
                                        视频{{ index }}-{{ ele.factoryNumber }}
                                    </div>
                                    <video
                                        :autoplay="false"
                                        controls
                                        controlslist="nodownload"
                                        :src="ele.videoUrl"
                                        style="width: 150px; height: 150px"
                                    ></video>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tipOperation-btn">
                        <div class="tipOperation-btn-lu" @click="saveData">
                            保存
                        </div>
                        <div class="tipOperation-btn-hon" @click="cancelData">
                            取消
                        </div>
                    </div>
                    <div class="video-conferenc-shuomi video-conferenc-border">
                        <div class="video-conferenc-border-title">
                            <span>操作说明</span>
                        </div>
                        <p>1.进行沟通准备工作</p>
                        <p>
                            2.准备完毕后点击开始录制（录制视频长度限制{{
                                minutes
                            }}分钟）
                        </p>
                        <p>3.录制过程中购机者按照农机部门要求进行操作</p>
                        <p>
                            4.农机部门按照所需拍照，且人机合照为必须上传
                            <!-- 4.农机部门按照所需图片类型进行截图（每种类型图片不能超过{{
                                photoNum
                            }}张） -->
                        </p>
                        <p>5.由农机部门点击挂断按钮结束本次视频通话</p>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="图片剪裁"
            :visible.sync="dialogVisible"
            append-to-body
            @close="closeCropper"
            :close-on-click-modal="false"
            width="35%"
            top="10px"
        >
            <el-form :model="form">
                <el-form-item label="图片类型">
                    <el-select v-model="form.type" placeholder="请选择图片类型">
                        <el-option
                            v-for="item in photoOptions"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                            <span style="float: left">{{ item.name }}</span>
                            <span
                                v-if="item.value == 'rjhz'"
                                style="
                                    float: right;
                                    color: red;
                                    font-size: 11px;
                                "
                                >*必须勾选</span
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="cropper-content">
                <div
                    class="cropper"
                    :style="{
                        width: img.width + 'px',
                        height: img.height + 'px'
                    }"
                >
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeCropper">取 消</el-button>
                <el-button type="primary" @click="finish" :loading="loading"
                    >确认</el-button
                >
            </div>
        </el-dialog>
        <audio
            src="@/assets/4532.mp3"
            controls="controls"
            ref="audio"
            style="display: none"
            loop
        ></audio>
    </div>
</template>

<script>
import Stomp from 'stompjs'
// var mediaRecorder; // MediaRecorder对象
import { mapState } from 'vuex'
import SearchUser from '../search-user'
import { getUsernameByUserid } from '../../service'
import html2canvas from 'html2canvas'
import HeaderNav from '../header-nav'
import HomePage from '../home-page'
import {
    getParam,
    callTime,
    record,
    recordend,
    uploadImg,
    delFile,
    saveApply,
    queueDelete
} from '@/api/index'
import { dataURLtoBlob, getNowDate, GetRequest } from '@/api/tools'
export default {
    name: 'VideoCall',
    components: {
        SearchUser,
        HeaderNav,
        HomePage
    },
    computed: {
        ...mapState({
            loginUserInfo: state => state.loginUserInfo,
            callStatus: state => state.callStatus,
            isInviter: state => state.isInviter,
            meetingUserIdList: state => state.meetingUserIdList,
            muteVideoUserIdList: state => state.muteVideoUserIdList,
            muteAudioUserIdList: state => state.muteAudioUserIdList
        })
    },
    data() {
        return {
            startRecordingShow: false,
            loading: false,
            recorFlg: false,
            isShowVideoCall: false,
            isVideoOn: true,
            isAudioOn: true,
            userId2Name: {},
            callFlag: false,
            cancelFlag: false,
            dataURL: '',
            videoUrl: '',
            imgArr: [],
            videoData: [],
            form: {
                type: null,
                imgUrl: ''
            },
            option: {
                img: '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                // autoCropWidth: 300,  // 默认生成截图框宽度
                // autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                fixedNumber: [1, 1], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                original: true, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的
            },
            imgUrl: '',
            dialogVisible: false,
            photoOptions: [],
            widths: '',
            heights: '',
            videoAreaFlg: false,
            minutes: '',
            photoNum: '',
            applicationNoList: {},
            BtnText: '',
            conut: 0,
            source: null,
            VideoArr: [],
            client: null,
            factoryNumber: [],
            engineNumber: [],
            engineNumberValue: '',
            factoryNumberValue: '',
            startTime: '',
            endTime: '',
            timer: null,
            img: {
                width: '',
                height: ''
            },
            loadingMask: null,
            isType: '',
            audioContext: null,
            source: null,
            element: null
        }
    },
    created() {
        this.connect()
    },
    mounted() {
        if (this.callStatus === 'connected' && !this.isInviter) {
            this.startMeeting()
            this.updateUserId2Name(this.meetingUserIdList)
        }
        if (window.location.search) {
            let obj = GetRequest(window.location.search)
            this.isType = obj.t
        }
        this.applicationData()
        // if (this.$store.state.setsubsidies.t == 1) {
        let data = {
            areaCode: this.$store.state.setsubsidies.applicationNo.substring(
                0,
                2
            ),
            type: this.isType
        }
        getParam(data).then(res => {
            this.photoOptions = res.videoType || []
            this.minutes = res.settingVideo.videoTime
            this.photoNum = res.settingVideo.photoCount
        })
        window.addEventListener('beforeunload', e =>
            this.beforeunloadHandler(e)
        )
    },
    beforeUpdate() {
        // if (this.isShowVideoCall) {
        //   let dom = this.getVideo();
        //   dom.addEventListener("loadedmetadata", this.onloadedmetadata());
        // }
    },
    destroyed() {
        this.videoUrl = ''
        this.videoData = []
        // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
        this.$store.commit('updateMuteVideoUserIdList', [])
        this.$store.commit('updateMuteAudioUserIdList', [])
        if (this.callStatus === 'connected') {
            this.$trtcCalling.hangup()
            this.$store.commit('updateCallStatus', 'idle')
        }
        window.removeEventListener('beforeunload', e =>
            this.beforeunloadHandler(e)
        )
    },
    watch: {
        callStatus: function (newStatus, oldStatus) {
            // 作为被邀请者, 建立通话连接
            if (newStatus !== oldStatus && newStatus === 'connected') {
                this.startMeeting()
                this.updateUserId2Name(this.meetingUserIdList)
                // this.$trtcCalling.on(this.TRTCCalling.EVENT.USER_ENTER, this.handleUserEnter);
            }
        },
        meetingUserIdList: function (newList, oldList) {
            if (newList !== oldList || newList.length !== oldList) {
                this.updateUserId2Name(newList)
            }
        }
    },
    methods: {
        loginout() {
            let promise = this.$trtcCalling.logout()
            promise
                .then(() => {})
                .catch(error => {
                    console.log('退出登录')
                })
        },
        beforeunloadHandler(e) {
            this.loginout()
            this.$store.state.autioEle.pause()
            this.$store.state.autioEle.remove()
            this.queueDeleteMthods()
        },
        applicationData(val) {
            if (val) {
                this.applicationNoList = val.applicationNoList
                this.factoryNumberValue =
                    this.applicationNoList.factoryNumber[0]
                this.isType = val.t
            }
        },
        queueDeleteMthods() {
            queueDelete({
                queueName: this.$store.state.setsubsidies.applicationNo
            }).then(res => {
                console.log(res)
            })
        },
        factoryNumberLinkage() {},
        onConnected(frame) {
            //绑定交换机exchange_pushmsg是交换机的名字rk_pushmsg是绑定的路由key
            var exchange =
                '/queue/' + this.$store.state.setsubsidies.applicationNo
            //创建随机队列用上面的路由key绑定交换机,放入收到消息后的回调函数和失败的回调函数
            this.client.subscribe(
                exchange,
                this.responseCallback,
                this.onFailed
            )
        },
        onFailed(frame) {
            console.log('Failed: ' + frame)
        },
        responseCallback(frame) {
            let data = JSON.parse(frame.body)
            data.factoryNumber = this.factoryNumberValue
            console.log(data)
            if (data.videoUrl) {
                this.loadingMask.close()
                this.VideoArr.push(data)
                if (this.applicationNoList.factoryNumber.length > 1) {
                    this.$alert(
                        '当前机具视频已经录制完成，如您多个机具的情况下，可在申请信息中的出厂编号进行下拉选择，您要核验的机具',
                        '温馨提示',
                        {
                            confirmButtonText: '确定'
                        }
                    )
                }
            }

            // self.VideoArr.push(data);
        },
        connect() {
            //这里填你rabbitMQ的连接ip地址直接替换localhost:15674就好其它的不用改
            // ws://192.168.1.108:15674/ws
            // wss://rtc.sxwhkj.com/ws
            this.client = Stomp.client('wss://rtc.sxwhkj.com/ws')
            //填写你rabbitMQ登录的用户名和密码
            var headers = {
                // login: "sxwhkjsphymq",
                // passcode: "sxwhkjsphy@B21#mq",
                login: 'guest',
                passcode: 'guest'
                //虚拟主机，默认“/”
                // "host": "/"
            }
            //创建连接,放入连接成功和失败回调函数
            this.client.connect(headers, this.onConnected, this.onFailed)
        },
        unique(arr) {
            const res = new Map()
            return arr.filter(
                a => !res.has(a.factoryNumber) && res.set(a.factoryNumber, 1)
            )
        },
        saveData() {
            if (this.startRecordingShow) {
                this.$message({
                    message: '请先结束录制后再点击保存',
                    type: 'warning'
                })
                return false
            }
            if (this.conut !== this.VideoArr.length) {
                this.$message({
                    message: '视频还在上传中请稍候点击',
                    type: 'warning'
                })
                return false
            }
            if (this.VideoArr.length <= 0) {
                this.$message({
                    message: `请上传视频`,
                    type: 'warning'
                })
                return false
            }
            let imgData = [],
                videoData = [],
                obj = {},
                arr = [] //拼接组装保存需要的数据
            imgData = this.unique([...this.imgArr, ...this.VideoArr])
            imgData.forEach(item => {
                videoData = []
                obj = {}
                this.imgArr.forEach((ele, index) => {
                    if (item.factoryNumber == ele.factoryNumber) {
                        if (obj[ele.keyName + 'Url']) {
                            Object.keys(obj).forEach(key => {
                                if (key == ele.keyName + 'Url') {
                                    obj[key] = obj[key] + ',' + ele.url
                                }
                            })
                        } else {
                            obj[ele.keyName + 'Url'] = ele.url
                        }
                    }
                })
                this.VideoArr.forEach(arr => {
                    if (arr.factoryNumber == item.factoryNumber) {
                        videoData.push(arr)
                    }
                })
                arr.push({
                    factoryNumber: item.factoryNumber,
                    applyId: this.applicationNoList.applyId,
                    applicationNo: this.applicationNoList.applicationNo,
                    areaCode: this.applicationNoList.areaCode,
                    state: 1,
                    year: this.applicationNoList.year,
                    type: this.isType,
                    videos: videoData,
                    ...obj
                })
            })
            let videoFlag = false,
                imgFlag = false,
                message = ''
            arr.forEach(item => {
                if (item.videos.length <= 0) {
                    message = item.factoryNumber
                    videoFlag = true
                }
                this.photoOptions.forEach(arr => {
                    if (!item.hasOwnProperty(arr.value + 'Url')) {
                        imgFlag = true
                    }
                })
            })
            if (arr.length != this.applicationNoList.factoryNumber.length) {
                // this.$message({
                //     message: `请根据出厂编号上传对应的图片和视频，您的资料不完整`,
                //     type: "warning",
                // });
                this.$message({
                    message: `请根据出厂编号上传对应的视频，您的资料不完整`,
                    type: 'warning'
                })
                return false
            }
            if (videoFlag) {
                this.$message({
                    message: `该出厂编号${message}视频不能为空`,
                    type: 'warning'
                })
                return false
            }
            var result_two = arr.find(v => {
                if (!v.rjhzUrl) {
                    return v
                }
            })
            if (result_two) {
                this.$message({
                    message: `该出厂编号${result_two.factoryNumber}的人机合照为空，请点击截图进行拍照`,
                    type: 'warning'
                })
                return false
            }
            // if(arr)
            // if (imgFlag) {
            //     this.$message({
            //         message: `请您确保图片类型是否都已上传`,
            //         type: "warning",
            //     });
            //     return false;
            // }
            if (this.$store.state.hangupStatus) {
                this.$message({
                    message: '请先挂断后再点击保存',
                    type: 'warning'
                })
                return false
            }
            console.log(arr)

            this.$confirm('此操作将保存视频以及图片, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: '保存中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                saveApply(arr)
                    .then(res => {
                        this.loadingMask.close()
                        if (res.code == 200) {
                            let msg = `<p style="color:#409eff;font-size: 18px;">${res.msg}</p>`
                            this.$alert(msg, '提示', {
                                confirmButtonText: '确定',
                                closeOnPressEscape: false,
                                closeOnClickModal: false,
                                showClose: false,
                                showCancelButton: false,
                                dangerouslyUseHTMLString: true,
                                callback: action => {
                                    this.$store.commit(
                                        'updateCallStatus',
                                        'idle'
                                    )
                                    this.isShowVideoCall = false
                                    this.$trtcCalling.hangup()
                                    window.opener.postMessage(-1, '*')
                                    window.close()
                                }
                            })
                        }
                        this.queueDeleteMthods()
                    })
                    .catch(err => {
                        this.loadingMask.close()
                        this.queueDeleteMthods()
                    })
                //挂断
                // hangup({
                //     applicationNo: this.applicationNoList.applicationNo,
                // }).then(res => {
                //     if (res.code == 200) {
                //         this.$store.commit("updateCallStatus", "idle");
                //         window.opener.postMessage(-1, '*')
                //         this.$trtcCalling.hangup();
                //         this.isShowVideoCall = false;
                //         // this.$message({
                //         //   type: "info",
                //         //   message: "已取消",
                //         // });
                //     }
                // })

                // this.$router.push("/");
                // window.close();
            })
        },
        cancelData() {
            if (this.startRecordingShow) {
                this.$message({
                    message: '请先结束录制后再点击取消',
                    type: 'info'
                })
                return false
            }
            this.$confirm('此操作将不保存视频与图片?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    // await this.$axios
                    //     .post("/api/file/getDelVedio", {
                    //         applicationNo: this.$store.state.setsubsidies.applicationNo,
                    //     })
                    //     .then((res) => { });

                    this.$store.commit('updateCallStatus', 'idle')
                    this.$trtcCalling.hangup()
                    this.isShowVideoCall = false
                    this.queueDeleteMthods()
                    window.close()
                })
                .catch(() => {})

            // this.$router.push("/");
        },
        // 关闭裁剪
        closeCropper() {
            this.dialogVisible = false
        },
        // 确认裁剪
        finish() {
            if (
                this.form.type == null ||
                this.form.type == '' ||
                this.form.type == undefined
            ) {
                this.$message({
                    message: '请选择图片类型',
                    type: 'warning',
                    customClass: 'global-messageZindex'
                })
                return false
            }
            // let flagType = false, imgRow, arrData = [];
            // arrData = this.unique(this.imgArr)
            // this.imgArr.forEach(item => {//判断相同类型的图片不能超过限制的总数
            //     if (item.factoryNumber == this.factoryNumberValue) {
            //         if (item.keyName == this.form.type && item.count >= this.photoNum) {
            //             flagType = true
            //             imgRow = item
            //         }
            //     }

            // })
            // if (flagType) {
            //     this.$message({
            //         showClose: true,
            //         message: `${imgRow.name}不能超过${this.photoNum}张`,
            //         type: "warning",
            //         customClass: 'global-messageZindex'
            //     });
            //     return false;
            // }

            this.dialogVisible = false
            this.$refs.cropper.getCropData(data => {
                // this.loading = true;
                let phtopName = this.photoOptions.filter(item => {
                    return this.form.type == item.value
                })
                let formData = new FormData()
                formData.append('file', dataURLtoBlob(data), '123.jpeg')
                formData.append(
                    'areaCode',
                    this.$store.state.setsubsidies.applicationNo.substring(0, 2)
                )
                uploadImg(formData).then(res => {
                    // this.imgArr.forEach(item => {//给相同类型的图片添加数量
                    //     if (item.keyName == this.form.type) {
                    //         item.count++
                    //     }
                    // })
                    if (res.code == 200) {
                        this.imgArr.push({
                            keyName: this.form.type,
                            url: res.data,
                            show: this.form.imgUrl,
                            name: phtopName[0].name,
                            factoryNumber: this.factoryNumberValue,
                            count: 1 //第一次默认添加数量1
                        })
                    }
                })
            })
        },
        handleUserEnter: function () {},
        deleteRow(index, rows) {
            let data = {
                keyName: rows.url,
                areaCode: this.applicationNoList.applicationNo.substring(0, 2)
            }
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(data).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.imgArr.splice(index, 1)
                    }
                })
            })
        },
        deleteVideo(rows, index) {
            let data = {
                keyName: rows.fileId,
                areaCode:
                    this.$store.state.setsubsidies.applicationNo.substring(0, 2)
            }
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(data).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.VideoArr.splice(index, 1)
                        this.conut--
                    }
                })
            })
        },
        formdataify(params) {
            const formData = new FormData()
            Object.keys(params).forEach(key => {
                if (typeof params[key] == 'string') {
                    formData.append(key, params[key])
                } else {
                    formData.append(key, JSON.stringify(params[key]))
                }
            })
            return formData
        },
        recordTime() {
            let count = 0
            this.timer = setInterval(() => {
                count++
                if (this.minutes == count) {
                    clearInterval(this.timer)
                    this.endRecording()
                }
                if (count == this.minutes - 2) {
                    this.$message({
                        message: `录制时间已经达到${
                            Number(this.minutes) - 2
                        }分钟，视频将在2分钟后自动结束录制`,
                        type: 'warning'
                    })
                }
            }, 60000)
        },
        getVideo() {
            let ele = document.getElementsByClassName(`video-item-username`)[1]
            let dom
            if (ele.nextSibling.firstChild.nodeName == 'VIDEO') {
                dom = ele.nextSibling.firstChild
            } else {
                dom = ele.nextSibling.lastChild
            }
            return dom
        },
        getAudio() {
            let ele = document.getElementsByClassName(`video-item-username`)[1]
            let dom
            if (ele.nextSibling.firstChild.nodeName == 'AUDIO') {
                dom = ele.nextSibling.firstChild
            } else {
                dom = ele.nextSibling.lastChild
            }
            return dom
        },
        handleUnpublish2() {
            if (!this.$store.state.hangupStatus) {
                return this.$message({
                    message: `视频通话已挂断，不允许该操作`,
                    type: 'warning'
                })
            }
            let ele = document.getElementsByClassName(`video-item-username`)[1]
            let dom
            if (ele.nextSibling.firstChild.nodeName == 'VIDEO') {
                dom = ele.nextSibling.firstChild
            } else {
                dom = ele.nextSibling.lastChild
            }
            this.img.width = dom.clientWidth
            this.img.height = dom.clientHeight
            this.option.autoCropHeight = dom.clientHeight
            this.option.autoCropWidth = dom.clientWidth
            html2canvas(dom)
                .then(res => {
                    var dataUrl = res.toDataURL('image/jpeg', 1.0) // 图片转为下载路径
                    if (
                        dataUrl != undefined &&
                        dataUrl != null &&
                        dataUrl != ''
                    ) {
                        this.form.imgUrl = dataUrl
                        this.option.img = dataUrl
                        this.dialogVisible = true
                        // this.imgArr.push({
                        //     imgUrl: dataUrl,
                        //     areaCode:  this.$store.state.setsubsidies.applicationNo.substring(0, 2)
                        // });
                    }
                })
                .catch(() => {})
        },
        startRecording() {
            if (this.startRecordingShow) {
                return
            }
            if (!this.$store.state.hangupStatus) {
                return this.$message({
                    message: `视频通话已挂断，不允许该操作`,
                    type: 'warning'
                })
            }
            this.startRecordingShow = true
            let dom = this.getVideo() //获取元素
            if (window.infoObj) {
                let info = JSON.parse(window.infoObj.data)
                let data = {
                    roomId: info.room_id,
                    recordId:
                        this.$store.state.setsubsidies.applicationNo +
                        '_' +
                        this.factoryNumberValue,
                    streamId: new Date().getTime(),
                    applicationNo: this.$store.state.setsubsidies.applicationNo,
                    factoryNumber: this.factoryNumberValue,
                    // RecordId: "3201110122000005",
                    userId: this.applicationNoList.appUId,
                    // userId: this.$store.state.setsubsidies.userId2,
                    videoWidth: dom.offsetWidth,
                    videoHeight: dom.offsetHeight,
                    applicationNo: this.$store.state.setsubsidies.applicationNo
                }
                // data = this.formdataify(data);
                record(data)
                    .then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '开始录制',
                                type: 'success'
                            })
                            this.recordTime()
                            this.recorFlg = true
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            })
                            this.startRecordingShow = false
                        }
                    })
                    .catch(err => {
                        this.$message({
                            message: '开始录制失败',
                            type: 'error'
                        })
                        this.startRecordingShow = false
                    })
            }
            // this.$mess1age.success("开始录制");
            // mediaRecorder.start();
        },
        // video元数据加载后触发
        // onloadedmetadata() {
        //   let video = this.getVideo();
        //   let audio = this.getVideo();
        //   mediaRecorder = new MediaRecorder(video.captureStream(25)); // 生成速率25的MediaRecorder对象

        //   const _this = this;
        //   mediaRecorder.ondataavailable = function (e) {
        //     _this.videoData.push(e.data); // 添加视频流
        //   };
        // },
        // 返回视频地址
        // showCapture() {
        //   return new Promise((resolve) => {
        //     setTimeout(() => {
        //       let blob = new Blob(this.videoData, {
        //         type: "video/mp4",
        //       });
        //       this.videoUrl = window.URL.createObjectURL(blob);
        //       resolve();
        //     });
        //   });
        // },
        suspendedDing() {
            // this.$message.success("暂停录制");
            // mediaRecorder.stop();
        },
        endRecording() {
            if (!this.$store.state.hangupStatus) {
                return this.$message({
                    message: `视频通话已挂断，不允许该操作`,
                    type: 'warning'
                })
            }
            if (!this.startRecordingShow) {
                this.$message({
                    message: '请先点击开始录制',
                    type: 'warning'
                })
                return false
            }
            if (window.infoObj) {
                let info = JSON.parse(window.infoObj.data)
                let data = {
                    roomId: info.room_id
                }
                // this.$confirm("此操作将结束录制, 是否继续?", "提示", {
                //   confirmButtonText: "确定",
                //   cancelButtonText: "取消",
                //   type: "warning",
                // })
                //   .then(() => {
                recordend(data).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: '结束录制',
                            type: 'success'
                        })
                        this.conut++
                        this.startRecordingShow = false
                        clearInterval(this.timer)
                        this.loadingMask = this.$loading({
                            lock: true,
                            text: '保存中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        })
                    }
                })
                // })
                // .catch(() => {
                //   this.$message({
                //     type: "info",
                //     message: "已取消",
                //   });
                // });
            }

            // mediaRecorder.stop();
            // this.showCapture();
        },
        handleCallUser: function ({ param }) {
            this.element = document.querySelector('.audiols')
            this.callFlag = true
            this.$trtcCalling
                .call({
                    userID: param,
                    type: this.TrtcCalling.CALL_TYPE.VIDEO_CALL
                })
                .then(() => {
                    this.callFlag = false
                    this.$store.commit(
                        'userJoinMeeting',
                        this.loginUserInfo.userId
                    )
                    this.$store.commit('updateCallStatus', 'calling')
                    this.$store.commit('updateIsInviter', true)
                    this.$store.commit('updataAutio', this.$refs.audio)
                    this.$refs.audio.load()
                    this.$refs.audio.play()
                })
                .catch(err => {
                    this.$store.commit('updataBtnText', '点击核验')
                    console.log(err)
                    let msg
                    if (err.toString().indexOf('UserID 无效或不存在') != -1) {
                        msg =
                            '<p style="color:red">购机者未在app端登录，请联系app用户！</p>'
                    } else if (
                        err.toString().indexOf('获取用户设备权限失败') != -1
                    ) {
                        msg =
                            '<p style="color:red">未检测到摄像头及语音功能，请重新安插设备！</p>'
                    } else if (
                        err
                            .toString()
                            .indexOf(
                                'TRTCCalling.call - CALL_STATUS: calling'
                            ) != -1
                    ) {
                        msg = '<p style="color:red">请刷新后再次尝试</p>'
                    } else if (
                        err.toString().indexOf('createMediaElementSource') != -1
                    ) {
                        msg = '<p style="color:red">请刷新后再次尝试</p>'
                    } else {
                        msg = '<p style="color:red">请点击确定重新拨打</p>'
                    }
                    this.$trtcCalling.hangup()
                    // if (flg) {
                    this.$alert(msg, '提示', {
                        confirmButtonText: '确定',
                        closeOnPressEscape: false,
                        showCancelButton: false,
                        dangerouslyUseHTMLString: true,
                        callback: action => {
                            window.location.reload()
                        }
                    })
                    // }
                })
        },
        handleCancelCallUser: function () {
            this.cancelFlag = true
            this.$trtcCalling.hangup().then(() => {
                this.cancelFlag = false
                this.$store.commit('dissolveMeeting')
                this.$store.commit('updateCallStatus', 'idle')
            })
        },
        handleUserAccept: function (event) {},
        startMeeting: function () {
            if (this.meetingUserIdList.length >= 3) {
                this.trtcCalling
                    .on(
                        this.TRTCCalling.EVENT.USER_ACCEPT,
                        this.handleUserAccept
                    )
                    .then(res => {})
                // 多人通话
                const lastJoinUser =
                    this.meetingUserIdList[this.meetingUserIdList.length - 1]
                this.$trtcCalling.startRemoteView({
                    userID: lastJoinUser,
                    videoViewDomID: `video-${lastJoinUser}`
                })
                this.$store.commit('updatahangupStatus', true)
                return
            }
            this.isShowVideoCall = true
            this.$trtcCalling.startLocalView({
                userID: this.loginUserInfo.userId,
                videoViewDomID: `video-${this.loginUserInfo.userId}`
            })
            // this.$trtcCalling.setRemoteRenderParams({
            //   userID: this.meetingUserIdList[this.meetingUserIdList.length - 1],
            //   // streamType:"",
            //   params:{
            //     TRTCVideoRotation:'TRTCVideoRotation_90' ,
            //     TRTCVideoResolutionMode:'Portrait'
            //   }
            // })
            const otherParticipants = this.meetingUserIdList.filter(
                userId => userId !== this.loginUserInfo.userId
            )
            otherParticipants.forEach(userId => {
                this.$trtcCalling.startRemoteView({
                    userID: userId,
                    videoViewDomID: `video-${userId}`
                })
            })
            this.startTime = getNowDate()
            this.$nextTick(() => {
                this.getVideo().parentNode.style =
                    'width: 100%;height: 100%;position: relative;background-color: black'
                let dom2 = document.getElementById(
                    `video-${this.loginUserInfo.userId}`
                )
                dom2.style =
                    'width:45%;height:250px;float:left;border: 1px solid #999'
                let dom = document.getElementById(
                    'video-' +
                        this.meetingUserIdList[
                            this.meetingUserIdList.length - 1
                        ]
                )
                dom.style =
                    'width:48%;float:right;height: 725px;min-height:525px;border: 1px solid #999'
            })
        },
        handleHangup: function () {
            // if (this.callStatus == "idle") {
            //     return (this.videoAreaFlg = true);
            // }
            // this.meetingUserIdList = []
            // if (this.videoAreaFlg) {
            //     return;
            // }
            // this.isShowVideoCall = true;
            if (this.startRecordingShow) {
                this.$message({
                    message: '请先结束录制后再点击挂断',
                    type: 'info'
                })
                return false
            }
            this.endTime = getNowDate()
            this.$store.commit('updateCallStatus', 'idle')
            let data = {
                startTime: this.startTime,
                endTime: this.endTime,
                applicationNo: this.applicationNoList.applicationNo
            }
            callTime(data).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    })
                }
            })
            this.videoAreaFlg = true
            this.$store.commit('updatahangupStatus', false)
            this.$store.commit('userJoinMeetingList', '购机者')
            this.$trtcCalling.hangup()
            this.loginout()
            // this.$store.commit("userLogoutSuccess");
            // this.isShowVideoCall = false;
            // this.$router.push("/");
            // this.meetingUserIdList.push("农户");
        },
        toggleVideo: function () {
            this.isVideoOn = !this.isVideoOn
            if (this.isVideoOn) {
                this.$trtcCalling.openCamera()
                const muteUserList = this.muteVideoUserIdList.filter(
                    userId => userId !== this.loginUserInfo.userId
                )
                this.$store.commit('updateMuteVideoUserIdList', muteUserList)
            } else {
                this.$trtcCalling.closeCamera()
                const muteUserList = this.muteVideoUserIdList.concat(
                    this.loginUserInfo.userId
                )
                this.$store.commit('updateMuteVideoUserIdList', muteUserList)
            }
        },
        toggleAudio: function () {
            this.isAudioOn = !this.isAudioOn
            this.$trtcCalling.setMicMute(!this.isAudioOn)
            if (this.isAudioOn) {
                const muteUserList = this.muteAudioUserIdList.filter(
                    userId => userId !== this.loginUserInfo.userId
                )
                this.$store.commit('updateMuteAudioUserIdList', muteUserList)
            } else {
                const muteUserList = this.muteAudioUserIdList.concat(
                    this.loginUserInfo.userId
                )
                this.$store.commit('updateMuteAudioUserIdList', muteUserList)
            }
        },
        isUserMute: function (muteUserList, userId) {
            return muteUserList.indexOf(userId) !== -1
        },
        updateUserId2Name: async function (userIdList) {
            let userId2Name = {}
            let loginUserId = this.loginUserInfo.userId
            for (let i = 0; i < userIdList.length; i++) {
                const userId = userIdList[i]
                if (!this.userId2Name[userId]) {
                    const userName = await getUsernameByUserid(userId)
                    userId2Name[userId] = userName
                    if (loginUserId === userId) {
                        userId2Name[userId] = '农机部门视频窗口'
                    } else {
                        userId2Name[userId] = '购机者视频窗口'
                    }
                }
            }
            this.userId2Name = {
                ...this.userId2Name,
                ...userId2Name
            }
        }
    }
}
</script>

<style scoped>
.tipOperation {
    text-align: left;
    color: #fff;
}

.video-confe1rence-action {
    display: flex;
}

.global-messageZindex {
    z-index: 3000 !important;
}

.cropper {
    width: auto;
    /* height: 300px; */
}

.btn_style_box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    /* margin: 0 20px; */
}

.btn_style {
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: rgba(255, 255, 255, 0.3); */
    margin: 0 auto;
    border-radius: 50px;
    cursor: pointer;
}

.btn_style img {
    height: 35px;
}

.btn_style_title {
    color: #fff;
    margin-top: 5px;
}

.video-conferenc-border-box {
    box-sizing: border-box;
    height: 100%;
    padding-top: 22px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
}

.screenshotsBox {
    width: 150px;
    height: 150px;
    background: #fff;
    position: relative;
    margin: 20px;
}

.callContent {
    display: flex;
}

.screenshots_title {
    height: 515px;
    min-height: 250px;
    border: 1px solid #fff;
    /* overflow: auto; */
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
}

.screenshots_title1 {
    height: 442px;
}

.screenshotsBox_decoration {
    position: absolute;
}

.decoration1 {
    right: 0px;
    font-size: 24px;
    color: red;
    z-index: 10;
}

.decoration2 {
    left: 35%;
    transform: translateX(-50%);
    top: 10%;
    z-index: 10;
    color: #fff;
    font-size: 12px;
}

.decoration3 {
    left: 0;
}

.video-call-section {
    /* padding-top: 20px; */
    width: 100%;
    margin: 0 auto;
}

.video-call-section-header {
    font-size: 24px;
}

.video-call-section-title {
    font-size: 20px;
}

.video-conference {
    display: none;
}

.video-conference.is-show {
    display: block;
    display: flex;
    justify-content: space-around;
}

.video-conference-list {
    /* display: flex; */
    /* flex-direction: row; */
    margin-top: 10px;
}

.user-video-container {
    position: relative;
    text-align: left;
    /* width: 360px;
  height: 240px; */
    margin: 10px;
    padding: 2px;
    box-sizing: border-box;
}

.user-video-status {
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 24px;
    height: 27px;
    z-index: 10;
    background-image: url('../../assets/camera-on.png');
    background-size: cover;
}

.user-video-status.is-mute {
    background-image: url('../../assets/camera-off.png');
}

.user-audio-status {
    position: absolute;
    left: 50px;
    bottom: 20px;
    width: 22px;
    height: 27px;
    z-index: 10;
    background-image: url('../../assets/mic-on.png');
    background-size: cover;
}

.user-audio-status.is-mute {
    background-image: url('../../assets/mic-off.png');
}

.video-conference-action {
    display: flex;
    margin-top: 10px;
}

.video-conferenc-btn {
    width: 48%;
    float: right;
    display: flex;
    justify-content: space-around;
    padding: 5px 0px;
    margin-right: 10px;
}

.video-conferenc-border {
    position: relative;
    border: 1px solid #999;
    box-sizing: border-box;
}

.video-conferenc-border-title {
    position: absolute;
    top: -25px;
    left: 50%;
    z-index: 100;
    width: 180px;
    height: 50px;
    background-image: url('../../assets/xx_07.png');
    background-size: 100% 100%;
    background-size: 100% 100%;
    transform: translateX(-50%);
    font-size: 22px;
    line-height: 50px;
    font-weight: 700;
    text-align: center;
    color: #2c3e50;
}

.video-item-username {
    position: absolute;
    top: -23px;
    left: 50%;
    z-index: 10;
    width: 250px;
    height: 40px;
    background-image: url('../../assets/spck.png');
    background-size: 100% 100%;
    background-size: 100% 100%;
    transform: translateX(-50%);
    font-size: 22px;
    line-height: 40px;
    font-weight: 700;
    text-align: center;
    color: #2c3e50;
}

.video-conferenc-shuomi {
    margin-top: 30px;
    padding: 25px 25px 10px;
    font-size: 18px;
}

.tipOperation-btn {
    justify-content: space-around;
    height: 71px;
    display: flex;
    align-items: center;
    padding-top: 15px;
}

.tipOperation-btn-lu {
    width: 140px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    background-image: linear-gradient(#f78839, #fda738);
    /* border: 1px solid #01ef5d; */
    border-radius: 15px;
    font-size: 20px;
}

.tipOperation-btn-hon {
    width: 140px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    /* border: 1px solid #c54057; */
    background: #c54057;
    border-radius: 15px;
    font-size: 20px;
    cursor: pointer;
}

.screenshots_title_list {
    padding: 25px 25px 0;
    list-style: none;
}

.screenshots_title_list li {
    margin-bottom: 25px;
    font-size: 20px;
    text-align: left;
}

.screenshots_title_list_biaot {
    color: #000;
    font-weight: 500;
}

.screenshots_title_list_text {
    color: #fff;
}

.btn_style_box_tm {
    opacity: 0.3;
}

.user-video-container:nth-last-child(3) {
    width: 48%;
    float: right;
    height: 725px;
    min-height: 525px;
    border: 1px solid #999;
}

@media screen and (max-width: 1650px) {
    .user-video-container:nth-last-child(3) {
        height: 525px !important;
    }

    .screenshots_title {
        height: 315px;
    }

    .screenshots_title1 {
        height: 250px;
    }

    .screenshots_title_list li {
        margin-bottom: 10px;
        font-size: 14px;
    }

    .video-conferenc-shuomi {
        padding: 25px 25px 0;
        font-size: 15px;
        height: 257px;
    }
}
</style>
